


/**
* Access Event Types within GuideStream
*/
export enum AccessEventType{
    /**
    * Waiting to join session
    */
    Waiting = 0,
    /**
    * Admitted to session
    */
    Admitted = 1,
    /**
    * Denied access to session
    */
    Denied = 2,
    /**
    * Removed from session
    */
    Removed = 3
}

